import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { bpeApi } from 'services/apiDigitalTicket/bpe';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';

import * as BpeActions from './actions';
import { BpeTypes } from './types';

function* getBpeConfig({
  payload,
}: ReturnType<typeof BpeActions.getBpeConfigRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando dados' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(bpeApi.getBpeConfig, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        BpeActions.getBpeConfigSuccess({
          bpeConfigData: {
            ...response.data,
            saleEmissionTypes: response.data.saleEmissionTypes
              ? typeof response.data.saleEmissionTypes === 'string'
                ? JSON.parse(response.data.saleEmissionTypes)
                : response.data.saleEmissionTypes
              : null,
          },
        }),
      );
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('bpe - settings - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(BpeActions.getBpeConfigFailure());
    yield put(DialogsActions.setClose());
  }
}

function* updateBpeConfig({
  payload,
}: ReturnType<typeof BpeActions.updateBpeConfigRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Editando configurações do BPE' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(bpeApi.updateBpeConfig, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        BpeActions.updateBpeConfigSuccess({
          bpeConfigData: {
            ...response.data,
            saleEmissionTypes: response.data.saleEmissionTypes
              ? typeof response.data.saleEmissionTypes === 'string'
                ? JSON.parse(response.data.saleEmissionTypes)
                : response.data.saleEmissionTypes
              : null,
          },
        }),
      );
      yield put(DialogsActions.setClose());
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Configuração do BPE alterada com sucesso',
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('bpe - updateBpeConfig - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(BpeActions.updateBpeConfigFailure());
    yield put(DialogsActions.setClose());
  }
}



// eslint-disable-next-line import/prefer-default-export
export const bpeSagas = [
  takeLatest(BpeTypes.GET_BPE_CONFIG_REQUEST, getBpeConfig),
  takeLatest(BpeTypes.UPDATE_BPE_CONFIG_REQUEST, updateBpeConfig),
];
